import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Badge } from 'softcat:components/badge.tsx';
import { BadgeState } from 'softcat:config/badge-state.ts';
import { CatalogueState } from 'softcat:config/catalogue-state.ts';

type CatalogueStatusProperties = {
    status: string;
};

export const CatalogueStatus: FunctionComponent<CatalogueStatusProperties> = ({ status }) => {
    switch (status) {
        case CatalogueState.OPEN: {
            return (
                <Badge status={BadgeState.WARNING}>
                    <FormattedMessage id={'CATALOGUE_STATUS_OPEN'} />
                </Badge>
            );
        }
        case CatalogueState.LIVE: {
            return (
                <Badge status={BadgeState.READY}>
                    <FormattedMessage id={'CATALOGUE_STATUS_LIVE'} />
                </Badge>
            );
        }
        case CatalogueState.ARCHIVE: {
            return (
                <Badge status={BadgeState.REVIEW}>
                    <FormattedMessage id={'CATALOGUE_STATUS_ARCHIVE'} />
                </Badge>
            );
        }
    }

    return <FormattedMessage id={'CATALOGUE_STATUS_UNKNOWN'} />;
};
